import React from 'react';

/** Coche animée (se dessine en 500 ms) pour toutes les confirmations. */
export const ToastCheck = () => (
  <span className="toast-check" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" className="toast-check-circle" />
      <path d="M7.5 12.5l3 3 6-6.5" className="toast-check-mark" />
    </svg>
  </span>
);

export default ToastCheck;
